<script>
    import { fly } from "svelte/transition";
    import { onMount } from "svelte";
    import { get } from "svelte/store";
    import { ST_gamestart, ST_gameend } from "./stores.js";

    let isVisible = false;
    onMount(() => {
        isVisible = true;
    });
</script>

<style>
    .has-image-centered {
        /* margin-top: 30px; */
        margin-left: auto;
        margin-right: auto;
    }
</style>

{#if isVisible}
    <div transition:fly={{ y: 100, duration:500 }} class="has-image-centered">
        <img
            class="has-image-centered"
            height="80%"
            src="EndGame.png"
            style="background-color:#FFFFFF;"
            alt="pict" />
    </div>
{/if}
